<template>
    <div>
        <bita-breadcrumb :items="breadCrumbs" />
        <div class="wrapper wrapper-content animated fadeInRight">
        <bita-ibox :is-loading="isLoadingGrid">
            <div slot="body">
            <bita-bootbutton
                title="افزودن پروژه جدید"
                type="primary"
                icon="fas fa-plus-square"
                btn-width="200px"
                @click.native="create"
                v-if="$acl.can('create', 'portfolios')"
            />
            <hr />
            <bita-grid
                ref="grid"
                :columns="gridColumns"
                :read-data="readData"
                :schema-total="'total'"
                :schema-data="'data'"
            />
            </div>
        </bita-ibox>
        </div>
        <portfolio-form ref="portfolioForm" :title="title" @load-data="loadData" />
        <portfolio-tech ref="portfolioTech" @load-data="loadData" />
        <portfolio-phase ref="portfolioPhase" @load-data="loadData" />
        <portfolio-images ref="portfolioImages" @load-data="loadData" />
    </div>
</template>
<script>
import { portfolioApi } from "@/api/apiManagement";
import PortfolioForm from "./components/PortfolioForm.vue";
import PortfolioTech from "./components/PortfolioTech.vue";
import PortfolioPhase from "./components/PortfolioPhase.vue";
import PortfolioImages from "./components/PortfilioImages.vue";

export default {
    components: {
        PortfolioForm,
        PortfolioTech,
        PortfolioPhase,
        PortfolioImages
    },
    data() {
        return {
            breadCrumbs: [
                { title: "صفحه اصلی", link: "/" },
                { title: "مدیریت پروژه‌ها‌", link: "/management/portfolios" },
            ],
            isLoadingGrid: false,
            title: "",
            techButton: 
                "<a role='button' class='k-button k-button-icontext k-grid-tech' data-toggle='tooltip' data-placement='bottom' title='تکنولوژی به کار رفته'><span class='fa fa-cubes' style='color:teal'></span></a>",
            phaseButton:
                "<a role='button' class='k-button k-button-icontext k-grid-phase' data-toggle='tooltip' data-placement='bottom' title='فازهای اجرایی'><span class='fa fa-braille' style='color:teal'></span></a>",
        }
    },
    mounted() {
        //
    },
    computed: {
        gridColumns() {
            return [
                { title: "عنوان" , template: (e) => ( e.title ? e.title : '-') },
                { title: "سال شروع پروژه", template: (e) => ( e.start_at ? this.$getJalaliDate(e.start_at) : '-') },
                { title: "سال پایان پروژه", template: (e) => (e.end_at ? this.$getJalaliDate(e.end_at) : '-') },
                { title: "عملیات", command: this.gridCommands() }
            ];
        }
    },

    methods: {
        readData(e) {
            portfolioApi.gets()
                .then( (res) => {
                    e.success(res.data.entity)
                })
                .catch( () => e.success([]) )
        },
        loadData() {
            this.$refs.grid.loadDataSource();
        },
        gridCommands() {
            let commands = [];
            commands.push({
                text: 'edit',
                click: this.edit,
                template: this.gridButtons.edit
            });
            commands.push({
                text: "tech",
                click: this.tech,
                template: this.techButton
            });
            commands.push({
                text: "phase",
                click: this.phase,
                template: this.phaseButton
            });
            commands.push({
                text: "images",
                click: this.images,
                template: this.gridButtons.images
            });
            commands.push({
                text: 'delete',
                click: this.delete,
                template: this.gridButtons.delete
            });
            return commands;
        },
        edit(e) {
            let portfolio = this.$refs.grid.getSelectedGridRow(e);
            this.title = `ویرایش پروژه ${portfolio.title}`;
            this.$refs.portfolioForm.setInitialData(portfolio);
            this.$toggleModal("#portfolio-form");
        },
        tech(e) {
            let portfolio = this.$refs.grid.getSelectedGridRow(e);
            this.$refs.portfolioTech.setInitialData(portfolio);
            this.$toggleModal("#portfolio-tech");
        },
        phase(e) {
            let portfolio = this.$refs.grid.getSelectedGridRow(e);
            this.$refs.portfolioPhase.setInitialData(portfolio);
            this.$toggleModal("#portfolio-phase");
        },
        images(e) {
            let portfolio = this.$refs.grid.getSelectedGridRow(e);
            this.$refs.portfolioImages.setInitialData(portfolio);
            this.$toggleModal("#portfolio-images");
        },
        delete(e) {
        let portfolio = this.$refs.grid.getSelectedGridRow(e);
        this.$alert(
            "question",
            `آیا از حذف ${portfolio.title} اطمینان دارید ؟`,
            "",
            {
            confirmButtonText: "بله",
            }
        ).then((result) => {
            if (result.value) {
            this.isLoadingGrid = true;
            portfolioApi
                .delete(portfolio.id)
                .then((res) => {
                    this.$izitoast("success", "عملیات موفق", res.data.message);
                    this.loadData();
                })
                .finally(() => {
                    this.isLoadingGrid = false;
                });
            }
        });
        },
        create() {
            this.title = "ایجاد پروژه جدید";
            this.$toggleModal('#portfolio-form');
            this.$refs.portfolioForm.setInitialData({});
        }
    }
}
</script>